import type { IconDefinition } from '../../types'

export default {
  details: [448, 512, [], '', 'M4.465 366.475l7.07 7.071c4.686 4.686 12.284 4.686 16.971 0L224 178.053l195.494 195.493c4.686 4.686 12.284 4.686 16.971 0l7.07-7.071c4.686-4.686 4.686-12.284 0-16.97l-211.05-211.051c-4.686-4.686-12.284-4.686-16.971 0L4.465 349.505c-4.687 4.686-4.687 12.284 0 16.97z'],
  name: 'uiChevronUp',
  oldName: 'falChevronUp'
} as IconDefinition
